module.exports = __webpack_public_path__ + "img/audicion.cd67a913.png";